import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { getApi } from '../api'

/**
 * Mints a public API v1 token. The resolved value carries `token` — the plaintext, which the
 * server does not store and cannot return again. Show it once, then drop it: it must not reach
 * a store, a log or a URL.
 */
export default () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      accountId,
      name,
      expiresAt,
    }: {
      accountId: number
      name: string
      expiresAt?: string | null
    }) => {
      const { api, baseURL } = getApi()
      return api
        .post(
          `/api/v2/accounts/${accountId}/public-api-tokens`,
          { name, expires_at: expiresAt || null },
          { baseURL, allow404: true },
        )
        .then((res) => res.data.data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-public-api-tokens'] })
    },
  })
}
